import React from "react";

function HowItWorks() {
  return (
    <div className='m-2'>
      <h2>Draw a Tree using Huffman Coding</h2>
      <hr className='m-1' />
      <iframe
        src='https://people.ok.ubc.ca/ylucet/DS/Huffman.html'
        frameBorder='0'
        title='Huffman Frame'
        width={window.innerWidth * 0.9}
        height={window.innerWidth * 0.7}></iframe>
    </div>
  );
}

export default HowItWorks;
